<template>
  <div>
    <div class="columns is-centered">
      <div class="column is-8 search-input">
        <div class="field has-addons has-addons-centered has-addons-fullwidth">
          <div class="control">
            <input
              v-model="domainInput"
              class="input is-large is-expanded"
              type="text"
              :placeholder="this.$t('domains.title')"
              @keyup.enter="searchDomain"
            >
          </div>
          <div class="control">
            <a
              class="button is-uppercase is-info is-large"
              @click.prevent="searchDomain"
            >
              {{ $t('common.search') }}
            </a>
          </div>
        </div>
        <div v-if="searching">
          <p class="search-loading">
            {{ $t('domains.search_loading') }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="!$v.domainInput.minLength">
      <div class="error">
        {{ $t('error.domaindame.min',{min_letters: $v.domainInput.$params.minLength.min}) }}
      </div>
    </div>
    <div v-if="!$v.domainInput.maxLength">
      <div class="error">
        {{ $t('error.domainname.max') }}
      </div>
    </div>
    <div v-if="!$v.domainInput.domainNameValidation">
      <div class="error">
        {{ $t('error.domainname.chars') }}
      </div>
    </div>
    <div
      v-if="!searching"
      class="columns is-centered"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { minLength, maxLength } from 'vuelidate/lib/validators'
import { domainNameValidation } from '@/helpers/custom-validators.js'

export default {
  name: 'DomainSearch',
  props: {
    input: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      domainInput: this.input
    }
  },

  computed: {
    ...mapState('domainService', {
      searching: state => state.searching
    })
  },

  validations () {
    return {
      domainInput: {
        minLength: minLength(3),
        maxLength: maxLength(253),
        domainNameValidation
      }
    }
  },

  methods: {
    searchDomain () {
      if (this.$v.domainInput.$anyError === false && this.$v.domainInput.$invalid === false) {
        var parsedDomain = this.$v.domainInput.$model.replace(/^(www\.)/, '')
        this.$emit('input', parsedDomain)
        this.$emit('search')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../sass/mystyles.scss';
.search-input {
  margin-top: 25px;

  input {
    border: 2px solid $white;
    height: 3.25em;
  }

  .button {
    width: 100%;
    padding-left: 5px;
    padding-right: 5px;
    height: 3.25em;
    background: var(--button-primary);
    border: 2px solid $white;

    &:hover {
      background: var(--button-primary-hovered);
      border: 2px solid $white;
    }
  }
}
.domain-heading {
  // background: var(--primary-color);
  letter-spacing: -0.506496px;
  width: 100%;
  margin-top: 25px;
  margin-bottom: 0px;
}
</style>
